import { MessageTypeEnum, OfferStatusEnum } from "@/Models/Chat";


export const getColorByLastMessage = (type: MessageTypeEnum, status: OfferStatusEnum) => {

  return {
    background: 
      status === OfferStatusEnum.PENDING ? '#FFC107'
      : status === OfferStatusEnum.ACCEPTED ? '#4CAF50'
      : status === OfferStatusEnum.REJECTED ? '#F44336'
      : status === OfferStatusEnum.CANCELED ? '#8a8a89'
      : status === OfferStatusEnum.SOLD ? '#8a8a89'
      : 'transparent',
    color:
      status === OfferStatusEnum.PENDING ? '#fff'
      : status === OfferStatusEnum.ACCEPTED ? '#fff'
      : status === OfferStatusEnum.REJECTED ? '#fff'
      : status === OfferStatusEnum.CANCELED ? '#fff'
      : status === OfferStatusEnum.SOLD ? '#fff'
      : '#000',

    ...(type === MessageTypeEnum.OFFER ? {
      padding: '5px 10px',
      borderRadius: '5px',
      fontSize: '12px',
    } : {})
  }
};